export default __webpack_public_path__ + "static/Large_Bear_Trap-4079932ad104863046bf9abb51c3563e.png";